import classNames from 'classnames'
import { MdCheckCircleOutline, MdContentCopy } from 'react-icons/md'

import type { PropsWithChildren, ReactElement, ReactNode } from 'react'

import { isValidJSON } from '~/utils/json'
import { copyText } from '~/utils/navigator'

import './styles.scss'

export const DataTableItem = ({
  actionMenu,
  className,
  copyEnabled = true,
  isJson,
  label,
  value,
}: {
  actionMenu?: ReactNode
  className?: string
  copyEnabled?: boolean
  isJson?: boolean
  label: string
  value?: ReactNode | null
}): ReactElement => {
  const handleCopy = () => typeof value === 'string' && copyText(value)

  return (
    <tr className={classNames('data-table-row-component', className)} onClick={handleCopy}>
      <td>{label}</td>
      <td className="cell-value">
        <div className="cell-value-content">
          {isJson ? <pre>{value}</pre> : value || '-'}{' '}
          {value && typeof value === 'string' && isJson && isValidJSON(value) ? (
            <MdCheckCircleOutline color="green" size={12} />
          ) : null}
        </div>
      </td>
      {copyEnabled ? (
        <td className="copy-action">
          <MdContentCopy size={12} />
        </td>
      ) : null}
      {actionMenu}
    </tr>
  )
}

const DataTable = ({ children, className }: PropsWithChildren<{ className?: string }>): ReactElement => {
  return (
    <div className={classNames('data-table-component', className)}>
      <table>
        <tbody>{children}</tbody>
      </table>
    </div>
  )
}

export default DataTable
